import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import {
  CopyOptionRecipeResponse, DeleteOptionRecipeResponse, Option, OptionKey, UpdateToppingRequest
} from './option.types';
import { Subrecipe } from "../subrecipe/subrecipe.types";

export const useGetOptions = (
    requestBody?: {
      classNo?: string;
      statusNo?: string;
    },
    enabled: boolean = true
) => {
  return useQuery<AxiosResponse<Option[]>>({
    queryKey: ['options', requestBody?.statusNo, requestBody?.classNo],
    queryFn: () =>
        apiClient.get<Option[]>('/options', { params: requestBody }),
    enabled
  });
};

export const useGetOption = (
    {
        classId,
        optionId
    }: OptionKey
) => {
  return useQuery({
    queryKey: ['getOption', classId, optionId],
    queryFn: () =>
        apiClient.get<Option>(`/classes/${classId}/options/${optionId}`)
  });
};

export const useUpdateOption = (
    {
        classId,
        optionId
    }: OptionKey
) => {
  return useMutation({
    mutationKey: ['updateOption', classId, optionId],
    mutationFn: (request: UpdateToppingRequest) =>
        apiClient.put<Option>(`/classes/${classId}/options/${optionId}`, request)
  });
};

export const useDeleteOption = (
    {
      classId,
      optionId
    }: OptionKey
) => {
  return useMutation({
    mutationKey: ['deleteOption', classId, optionId],
    mutationFn: () =>
        apiClient.delete(`/classes/${classId}/options/${optionId}`)
  })
}

export const useGetSubRecipeOptions = (
  requestBody: { classNo: string; baseNo?: string; sizeNo?: string; productNo?: string },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Option[]>>({
    queryKey: [
      'getSubRecipeOptions',
      requestBody.classNo,
      requestBody.baseNo,
      requestBody.sizeNo,
      requestBody.productNo
    ],
    queryFn: () => apiClient.get<Option[]>('/sub-recipes/options', { params: requestBody }),
    enabled
  });
};

export const useCopyOptionRecipes = () => {
  return useMutation<AxiosResponse<CopyOptionRecipeResponse[]>, unknown, number[]>(
    (body: number[]) => {
      return apiClient.post<CopyOptionRecipeResponse[]>(`/sub-recipes`, body);
    }
  );
};

export const useDeleteOptionRecipes = () => {
  return useMutation<AxiosResponse<DeleteOptionRecipeResponse[]>, unknown, Subrecipe[]>(
      (optionRecipes: Subrecipe[]) => {
        return apiClient.post<DeleteOptionRecipeResponse[]>(`/sub-recipes/delete`, optionRecipes)
      }
  )
}